export default __webpack_public_path__ + "static/pexels-roger-brown-5149753_-367713ae1b58333d08bde571e485251d.jpg";